import React from "react";

import { ZeosLabel } from "./ZeosLabel";

interface IZeosSelectProps {
  label?: string;
  name: string;
  value: string;
  options: string[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  required?: boolean;
}

export const ZeosSelect = (props: IZeosSelectProps) => {
  const {
    label,
    name,
    value,
    options,
    onChange,
    disabled = false,
    required = false,
  } = props;
  return (
    <div className="mb-2 w-full">
      {label && <ZeosLabel label={label} htmlFor={name} required={required} />}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`
          w-full rounded border px-3 py-2
          border-[#929293] bg-white text-[1.125rem]
          text-zeos-black font-light font-sans
          focus:outline-none focus:ring-2 focus:ring-zeos-blue
          transition-all duration-150
        `}
      >
        <option value="">Select an option</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};
